/* tslint:disable */
/* eslint-disable */
/**
 * Subscription App API
 * Provides management of all subscription operations at subscription app tier.
 *
 * The version of the OpenAPI document: 1.11.2
 * Contact: Pankaj.Gautam@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * PENDING, PROCESSING_FAILED, PAUSED, ORDER_CREATED, COMPLETED, CANCELLED
 * @export
 */
export const ElementStatus = {
    Pending: 'PENDING',
    Paused: 'PAUSED',
    OrderCreated: 'ORDER_CREATED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    ProcessingFailed: 'PROCESSING_FAILED'
} as const;
export type ElementStatus = typeof ElementStatus[keyof typeof ElementStatus];


export function ElementStatusFromJSON(json: any): ElementStatus {
    return ElementStatusFromJSONTyped(json, false);
}

export function ElementStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementStatus {
    return json as ElementStatus;
}

export function ElementStatusToJSON(value?: ElementStatus | null): any {
    return value as any;
}

